// 编辑器store
import {observable, action, makeObservable, flow} from 'mobx';
import _ from 'lodash';
import {getTemplateList, getPublicTemplateList} from '../services';

export class TemplateStore {
    usedTemplate = [];
    lastClicked = {};
    customTemplateList = [];
    pubTemplateList = [];

    constructor() {
        makeObservable(this, {
            usedTemplate: observable, // 已使用的模板列表
            lastClicked: observable, // 上次点击内容
            customTemplateList: observable,
            pubTemplateList: observable,

            getTemplateList: action,
            clearUsedTemplate: action, // 清空列表
            setUsedTemplate: action, // 设置列表
            addUsedTemplate: action, // 添加内容
            setLastClicked: action // 设置上次点击的内容
        });
    }
    getCustomData = flow(function* () {
        const res = yield getTemplateList({
            pn: '1',
            rn: '5000'
        });
        const list = _.get(res, 'data.list', []);
        this.customTemplateList = list.filter(item => item.template_data);
    });
    getPubData = flow(function* () {
        const res = yield getPublicTemplateList({});
        const list = _.get(res, 'data.list', []);
        this.pubTemplateList = list.filter(item => item.template_data);
    });
    getTemplateList = (isForce) => {
        if (!this.customTemplateList.length || isForce) {
            this.getCustomData();
        }

        if (!this.pubTemplateList.length) {
            this.getPubData();
        }
    };

    clearUsedTemplate = () => {
        this.usedTemplate.splice();
    };

    setUsedTemplate = templateList => {
        this.usedTemplate = templateList;
        this.lastClicked = templateList?.findLast(item => item.template_type !== 'paster') || {};
    };

    addUsedTemplate = template => {
        this.usedTemplate.push(template);
    };

    setLastClicked = template => {
        this.lastClicked = template;
    };
}
